// extracted by mini-css-extract-plugin
export default {"cities":"region-main-organizations_cities__+njYa"};